<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Service Providers Non Travellers</h3>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="nonTravellers"
                :loading="loading"
                :items-per-page="rowsPerPage"
                item-key="id"
                class="elevation-1"
                hide-default-footer
            >
              <template v-slot:item.s_no="{ index }">
                {{ (page - 1) * rowsPerPage + index + 1 }}
              </template>
              <template v-slot:item.country_name="{ item }">
                {{ item.country_name || '-' }}
              </template>
              <template v-slot:item.service_provider_name="{ item }">
                {{ item.service_provider_name || '-' }}
              </template>
              <template v-slot:item.document_number="{ item }">
                {{ item.document_number || '-' }}
              </template>
              <template v-slot:item.purpose="{ item }">
                {{ item.purpose || '-' }}
              </template>
              <template v-slot:item.action_date="{ item }">
                {{ item.action_date || '-' }}
              </template>


              <!-- Custom Footer with Pagination Controls -->
              <template v-slot:footer>
                <v-divider></v-divider>
                <div class="d-flex align-center justify-space-between pa-3 flex-wrap">

                  <!-- Rows per page dropdown -->
                  <div class="d-flex align-center">
                    <span class="grey--text caption mr-2">Rows per page:</span>
                    <v-select
                        v-model="rowsPerPage"
                        :items="rowsPerPageOptions"
                        dense
                        hide-details
                        outlined
                        style="max-width: 80px; font-size: 13px;"
                        @change="onRowsPerPageChange"
                    ></v-select>
                  </div>

                  <!-- Showing X of Y -->
                  <div class="grey--text caption mx-4">
                    Showing
                    {{ total === 0 ? 0 : (page - 1) * rowsPerPage + 1 }}–{{ Math.min(page * rowsPerPage, total) }}
                    of {{ total }} records
                  </div>

                  <!-- Prev / Next buttons -->
                  <div class="d-flex align-center">
                    <v-btn
                        icon
                        small
                        :disabled="page <= 1 || loading"
                        @click="prevPage"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>

                    <span class="mx-2 caption grey--text">
                      Page {{ page }} of {{ totalPages }}
                    </span>

                    <v-btn
                        icon
                        small
                        :disabled="page >= totalPages || loading"
                        @click="nextPage"
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>

                </div>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FileInput from "../components/FileInput";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {validationMixin} from "../mixins/validationMixin";
import RefreshButton from "@/components/RefreshButton";
import FileDisplay from "../components/FileDisplay";
import TableStatus from "@/components/TableStatus";
import Http from "axios";
import {buildFormData} from "../helpers/FormedData";
import {API_URL, VERSION} from "../config/config";

export default {
  name: "ServiceProviderNonTravellers",
  components: {FileDisplay, RefreshButton, FormErrorDisplayHandler, FileInput, TableStatus},

  data() {
    return {
      nonTravellers: [],
      page: 1,
      rowsPerPage: 50,
      rowsPerPageOptions: [10, 25, 50, 100,500],
      totalPages: 0,
      total: 0,
      loading: false,
      headers: [
        { text: 'S.N.',            value: 's_no',                  sortable: false },
        { text: "Country",         value: "country_name",          sortable: false },
        { text: "Service Provider",value: "service_provider_name", sortable: false },
        { text: "Document Number", value: "document_number",       sortable: false },
        { text: 'Purpose',         value: 'purpose',               sortable: false },
        { text: 'Action Date',     value: 'action_date',           sortable: false },
      ],
    };
  },

  mixins: [validationMixin],

  methods: {
    view(item) {
      this.$router.push({
        name: "ViewServiceProvider",
        params: { id: item.id }
      });
    },

    edit(item) {
      // handle edit
    },

    async confirmDelete(item) {
      // handle delete
    },

    // Called when rows per page dropdown changes
    onRowsPerPageChange() {
      this.page = 1; // reset to first page
      this.loadNonTravellers();
    },

    prevPage() {
      if (this.page > 1 && !this.loading) {
        this.page--;
        this.loadNonTravellers();
      }
    },

    nextPage() {
      if (this.page < this.totalPages && !this.loading) {
        this.page++;
        this.loadNonTravellers();
      }
    },

    async loadNonTravellers() {
      const providerId = this.$route.params.id;
      if (!providerId) return;

      this.loading = true;

      const url = `${API_URL}${VERSION}/service-provider-non-travellers-count/${providerId}`;

      try {
        const response = await Http.get(url, {
          params: {
            page: this.page,
            rowsPerPage: this.rowsPerPage,
          }
        });

        const { data, last_page, total } = response.data;

        // Replace data on each page change (not append)
        this.nonTravellers = data;
        this.totalPages = last_page || 1;
        this.total = total || 0;

      } catch (error) {
        console.error("Error fetching non-travellers:", error);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.loadNonTravellers();
  }
}
</script>

<style scoped>
</style>